import { EventCategory } from "./type";

export const VI_EVENT_CATEGORY: EventCategory = {
  all: "Tất cả",
  workshop: "Workshop",
  course: "Khóa học",
  meetup: "Gặp gỡ"
};
